// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3VkVY","inputWrap":"Table_inputWrap__29IFB","col":"Table_col__1PvoH","bmiTooltip":"Table_bmiTooltip__Hlfdf"};